import { render, staticRenderFns } from "./MediaPdfs.vue?vue&type=template&id=4ab9ba03&scoped=true&"
import script from "./MediaPdfs.vue?vue&type=script&lang=js&"
export * from "./MediaPdfs.vue?vue&type=script&lang=js&"
import style0 from "./MediaPdfs.vue?vue&type=style&index=0&id=4ab9ba03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab9ba03",
  null
  
)

export default component.exports